const getPresentedEvent = (mab) => ({
    eventName: 'multi_armed_bandit.presented',
    payload: {
        campaign_id: mab.campaignId,
        bandit_id: mab.banditId,
        arm_id: mab.arm.id,
    },
});

const getSelectedEvent = (mab, event) => ({
    eventName: 'multi_armed_bandit.selected',
    payload: {
        campaign_id: mab.campaignId,
        bandit_id: mab.banditId,
        arm_id: mab.arm.id,
        reward_event_id: event.id,
    },
});

const getEventOptions = (mab, event) => {
    return event.type === 'PRESENT'
        ? getPresentedEvent(mab)
        : getSelectedEvent(mab, event);
};

const isTargetEvent = (filter, edapEvent) => {
    if (filter) {
        const [key, value] = filter.split(':');
        if (!edapEvent[key] || edapEvent[key].indexOf(value) === -1) {
            return false;
        }
    }
    return true;
};

const dispatch = (edap, {eventName, payload}, filter) => (edapEvent) => {
    if (!isTargetEvent(filter, edapEvent)) {
        return;
    }

    edap.trigger(eventName, {...payload, visitor_id: edapEvent.visitorid});
};

const subscribe = (mabContext, edap) => {
    const {events} = mabContext;

    try {
        events.forEach((event) =>
            edap.on(
                event.edapEventType,
                dispatch(edap, getEventOptions(mabContext, event), event.filter)
            )
        );
    } catch (error) {
        return;
    }
};

/**
 * Registers a list of events based on provided mabContext.
 * If passed edap object is not initialized, it pushes a new function to wait
 * for EDAP to callback once ready
 * @param {object | Array} edap - edap object or array
 * @param {object} mabContext - Mab context data from initial state
 */
export const register = (edap, mabContext = {}) => {
    if (!edap || !mabContext.arm) {
        return;
    }

    if (!edap.on && !edap.off) {
        edap.push((edapInstance) => subscribe(mabContext, edapInstance));
    } else {
        subscribe(mabContext, edap);
    }
};
